import { getDetails, getList, remove, set } from 'src/core/redux/actions';
import { User } from 'src/core/models';
import { state as stateConstants } from 'src/constants';
import LocalStorageService from 'src/core/services/LocalStoregeService';

export const resetUserDetails = () => (dispatch) => {
  dispatch(remove(User.NAME, 'type'));
  dispatch(remove(User.NAME, 'details'));

  LocalStorageService.removeItem('loggedUser');
};

export const fetchAccessAndUserData = () => async (dispatch) => {
  const userType = await dispatch(getDetails(User, 'type', { url: User.getTypeConfig().url })());

  if (userType?.data && (!!(userType.data?.isAnonymous))) {
    return;
  }

  const userRes = await dispatch(getList(User)());

  if (userRes.status === 200) {
    await dispatch(set(
      User.NAME,
      stateConstants.IDENTIFIER_TYPE_DETAILS,
      {
        data: { ...userRes?.consumers?.[0]?.user }
      }
    ));
  } else {
    dispatch(resetUserDetails());
  }
};
